RivalIQ.apps.Share.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Body = Marionette.View.extend({
        events: {
            'click #btnAddToAccount': 'addToAccount'
        },
        addToAccount: function () {

            const me = this;
            const model = me.model;
            const newLandscape = new App.models.CloneIntoAccount();

            newLandscape.set({
                _csrf: me.$('#btnAddToAccount').val(),
                uuid: model.get('uuid')
            });

            me.$('.x-current-customer-pre .x-loading-msg').show();
            me.$('.x-current-customer-pre button').addClass('disabled');

            setTimeout(function () {
                newLandscape.save({})
                    .done(function () {
                        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.V3ClonePageConversion);
                        me.$('.x-current-customer-pre').hide(250);
                        me.$('.x-current-customer-success').show(250);
                    })
                    .fail(function (xhr) {
                        const errorObj = xhr.errorObj;

                        me.$('.x-current-customer-pre .x-loading-msg').hide(250);

                        if (_.get(errorObj, 'name') === 'TooManyCompaniesAddedInPeriodError') {
                            me.$('.x-too-many-companies-in-period').css({
                                display: 'inline'
                            });
                        }

                        if (_.get(errorObj, 'name') === 'TooManyLandscapesError') {
                            me.$('.x-too-many-landscapes').css({
                                display: 'inline'
                            });
                        }

                        me.$('.x-current-customer-error').show(250);
                    });
            }, 2000);
        }
    });

});
